<template>
  <Head>
    <link
      v-for="href in hrefs"
      :key="href"
      rel="stylesheet"
      :href="href"
    >
  </Head>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Head } from '@inertiajs/vue3';
import { fontLinkHref, type FontLink } from '@/utils/fontLinks';

const props = defineProps<{ fonts: FontLink[] }>();

const hrefs = computed<string[]>(() =>
  props.fonts
    .map(fontLinkHref)
    .filter((href): href is string => href !== null),
);
</script>
